import React from 'react';
import css from './OpenBlocksTemplate.scss';
import { useOpenBlocksEditorUrl } from '../../hooks/useOpenBlocksEditorUrl';
import BlockLoader from '../../assets/images/blocks_loader.mp4';
import { Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../constants/dataHooks';
import classNames from 'classnames';

export const OpenBlocksTemplate = () => {
  const { isError } = useOpenBlocksEditorUrl();
  const { t } = useTranslation();
  return (
    <div className={classNames(css.base, { [css.error]: isError })}>
      {isError ? (
        <Heading
          dataHook={DataHooks.OpenBlocksFlowError}
          size="medium"
          className={css.message}
        >
          {t('app.template-page.open-blocks-template-flow.error')}
        </Heading>
      ) : (
        <video
          height="200px"
          width="200px"
          src={BlockLoader}
          autoPlay
          loop
          muted
          playsInline
        />
      )}
    </div>
  );
};
